import { Stack } from "@mui/material";
import { memo } from "react";
import TriageItem from "./TriageItem";
import {
  ITriageCheckInRule,
  ITriageEmergencyDepartments,
} from "../../../models/triage";

interface ITriageListProps {
  data: ITriageEmergencyDepartments[];
  checkInRule: ITriageCheckInRule;
}

const TriageList: React.FC<ITriageListProps> = ({ data, checkInRule }) => {
  return (
    <Stack gap={1} mt={1}>
      {data &&
        data.map((s) => (
          <TriageItem data={s} key={s.id} checkInRule={checkInRule} />
        ))}
    </Stack>
  );
};

export default memo(TriageList);
